var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1196_332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.9998 14.3275L79.818 11.382L76.8725 10.9457C76.618 10.9093 52.1089 7.34568 41.9998 0.618404L39.9998 -0.727051L37.9998 0.618404C27.8907 7.34568 3.38161 10.9093 3.12706 10.9457L0.181608 11.382L-0.000210628 14.3275C-0.0729379 15.8548 -1.96385 51.4184 15.1634 69.6002C18.3315 72.9926 22.1836 75.6739 26.4651 77.4667C30.7465 79.2595 35.3598 80.123 39.9998 80.0002C44.6398 80.123 49.2531 79.2595 53.5345 77.4667C57.816 75.6739 61.6681 72.9926 64.8362 69.6002C81.9634 51.4184 80.0725 15.8548 79.9998 14.3275ZM60.2907 35.673L34.8362 53.8548C34.2297 54.3136 33.4874 54.5568 32.7271 54.5457C32.5073 54.5394 32.2883 54.5151 32.0725 54.4729C31.5923 54.3886 31.1346 54.2062 30.7279 53.9372C30.3213 53.6681 29.9744 53.3183 29.7089 52.9093L22.4362 42.0002C21.9107 41.1997 21.7237 40.2237 21.9161 39.2856C22.1085 38.3476 22.6647 37.524 23.463 36.995C24.2612 36.4661 25.2364 36.2749 26.1753 36.4633C27.1141 36.6517 27.9401 37.2043 28.4725 38.0002L33.6725 45.782L56.0725 29.782C56.4593 29.5051 56.8969 29.307 57.3602 29.1991C57.8236 29.0913 58.3036 29.0757 58.773 29.1534C59.2424 29.2311 59.6918 29.4004 60.0957 29.6518C60.4996 29.9031 60.8501 30.2316 61.1271 30.6184C61.404 31.0052 61.6021 31.4428 61.71 31.9061C61.8178 32.3695 61.8334 32.8495 61.7557 33.3189C61.678 33.7883 61.5087 34.2377 61.2573 34.6416C61.006 35.0455 60.6775 35.396 60.2907 35.673Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1196_332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.8bb5d3810c2c1f409324858ce0c7caa5.svg";
export { ForwardRef as ReactComponent };